document.addEventListener('DOMContentLoaded', function() {
  const scrollIndicator = document.getElementById('scroll-indicator');
  
  // Check if we need to show the indicator (if page is scrollable)
  function checkScrollHeight() {
    if (document.body.scrollHeight > window.innerHeight + 200) {
      scrollIndicator.style.opacity = '1';
    } else {
      scrollIndicator.style.opacity = '0';
    }
  }
  
  // Hide indicator when near bottom of page
  function handleScroll() {
    const scrollPosition = window.scrollY + window.innerHeight;
    const scrollThreshold = document.body.scrollHeight - 200;
    
    if (scrollPosition > scrollThreshold) {
      scrollIndicator.style.opacity = '0';
    } else if (scrollPosition < window.innerHeight + 200) {
      scrollIndicator.style.opacity = '1';
    }
  }
  
  // Smooth scroll when indicator is clicked
  scrollIndicator.addEventListener('click', function() {
    window.scrollBy({
      top: window.innerHeight / 2,
      behavior: 'smooth'
    });
  });
  
  // Run checks
  checkScrollHeight();
  window.addEventListener('scroll', handleScroll);
  window.addEventListener('resize', checkScrollHeight);
});